import { jsx } from 'react/jsx-runtime';
import { Button as Button$1 } from '../../Button/index.js';

function Button(props) {
    if (typeof props.children === "string") {
        return (jsx(Button$1.Wrapper, Object.assign({}, props, { color: "secondary", variant: "outlined", children: jsx(Button$1.Text, { children: props.children }) })));
    }
    return jsx(Button$1.Wrapper, Object.assign({}, props, { color: "secondary", variant: "outlined" }));
}

export { Button };
//# sourceMappingURL=Button.js.map
